import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveInstance = (state, instance) => state.some((item) => item.insuranceInfoId === instance.insuranceInfoId);

export const insuranceInfosSlice = createSlice({
  name: 'insuranceInfos',
  initialState: initialState,
  reducers: {
    clearInsuranceInfos: () => {
      return initialState;
    },

    addInsuranceInfo: (state, action) => {
      const instance = action.payload;
      return haveInstance(state, instance) ? state : state.concat(instance);
    },
  },
});

export const { clearInsuranceInfos, addInsuranceInfo } = insuranceInfosSlice.actions;

export default insuranceInfosSlice.reducer;
